var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{staticClass:"tag-box",attrs:{"label":_vm.tagLabel,"multiple":"","chips":"","deletable-chips":true,"prepend-icon":"tag_faces"},model:{value:(_vm.customTags),callback:function ($$v) {_vm.customTags=$$v},expression:"customTags"}})
}
var staticRenderFns = []

export { render, staticRenderFns }